module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJdJREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9JIqcUPgEF6kByNTAOVuEYtHrV41OJRi0ctHoYWAxsA+sSI0cLHE4AWxSNZOh9IBdArqGGVfwEQJ9ArjguQWhgCQHwBFAp0aexB4/QAtG3lAGyFfKRbqgRZDsT8ow31QQ8AAgwA8mUb+UNck+AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/2.png
// module id = 757
// module chunks = 0